export function setAuth(username, token, refreshToken, userRoles, terminalId, userTerminals, userSettings) {
  return {
    type: 'SET_AUTH',
    username,
    token,
    refreshToken,
    userRoles,
    terminalId,
    userTerminals,
    userSettings
  }
}

export function setNewToken(token, refreshToken) {
  return {
    type: 'SET_NEW_TOKEN',
    token,
    refreshToken
  }
}

export function clearAuth() {
  return {
    type: 'CLEAR_AUTH'
  }
}

export function switchTerminal(terminalId, userRoles) {
  return {
    type: 'SET_NEW_TERMINAL',
    payload: {
      terminalId,
      userRoles
    }
  }
}
